export default "__VITE_ASSET__79b8b75b__"